import { array, enums, integer, object, string } from 'superstruct';
import { stringDate } from '@arc/shared/util-superstruct';
const DEPLOYMENT_STATUSES = ['QUEUED', 'PENDING', 'SUCCESS', 'FAILURE'];
export const ViewArcGroupImportDto = object({
  id: integer(),
  status: enums(DEPLOYMENT_STATUSES),
  updatedAt: stringDate(),
  newGroups: array(object({
    id: integer(),
    odooId: integer(),
    name: string()
  }))
});